export default __webpack_public_path__ + "img/swci.a91986b8.png";